import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'


import '@/styles/index.css'

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control

import i18n from './i18n'

//ui https://lanhuapp.com/web/#/item/project/board?pid=4f96804f-d4f5-46b5-97e2-bedf98bf87de
//api http://192.168.6.113:8003/Home/item/show?item_id=9
//demo http://wei.fsnmt.com/uploads/test/index.html#/training/index
//http://ztz.fstcb.com/   http://admin.fstcb.com/  账号：admin 密码：123456
//新地址 http://www.uniceramics.com.cn/index/

// import { mockXHR } from '../mock'
// if (process.env.NODE_ENV === 'production') {
//   mockXHR()
// }

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  loading: require('@/assets/load.png')
})

// set ElementUI lang to EN
Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  mounted(){
    document.dispatchEvent(new Event('custom-render-trigger'))
  }
})
